import { useClientByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import { useCountryMapping } from 'hooks/useCountryMapping';

export const useAddress = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { countryMapping } = useCountryMapping();
  const { data: clientDetails = {} } = useClientByIdQuery({ id });

  const countryDetails = useMemo(() => {
    return countryMapping[clientDetails.country] || {};
  }, [countryMapping, clientDetails]);

  const onModalOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onModalClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onModalOpen,
    onModalClose,
    clientDetails,
    countryDetails,
  };
};
